/* ============================================================
 * Ad attribution capture — VELDORO
 * ------------------------------------------------------------
 * Checkout happens on Whop, so the browser session that saw the ad never
 * reaches the order. Unless these identifiers are captured here and forwarded,
 * every order arrives unattributed and wetracked, Meta CAPI and profit tools
 * cannot connect a sale to the campaign that produced it.
 *
 * Click ids arrive on the LANDING page, which is usually not the page where
 * checkout is clicked, so they are persisted on first sight and read back
 * later. Meta's own cookies (_fbp/_fbc) are read at checkout time, since the
 * pixel sets them after landing.
 *
 * Exposes window.WHOP_ATTRIBUTION.collect().
 * ============================================================ */
(function () {
  'use strict';

  var STORE_KEY = 'whop_attribution_v1';

  /* Query parameters worth keeping. utm_* is matched by pattern. */
  var PARAMS = [
    'fbclid', 'gclid', 'wbraid', 'gbraid', 'ttclid', 'sccid', 'scclid',
    'epik', 'li_fat_id', 'msclkid', 'irclickid', 'rdt_cid', 'twclid',
    'wt_id', 'wetracked_id'
  ];

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(data) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) {
      /* Private mode or storage full: attribution degrades, checkout does not. */
    }
  }

  function cookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[2]) : null;
    } catch (e) {
      return null;
    }
  }

  /* Runs on every page load. The landing page carries the click id and is
   * usually not the page where checkout happens. First value wins, so a later
   * untagged page view cannot erase the original campaign. */
  function capture() {
    var stored = readStore();
    var changed = false;

    try {
      var qs = new URLSearchParams(window.location.search);
      qs.forEach(function (value, key) {
        var k = String(key).toLowerCase();
        var keep = PARAMS.indexOf(k) !== -1 || /^utm_[a-z0-9_]+$/.test(k);
        if (!keep || !value) return;
        if (stored[k] === undefined) {
          stored[k] = value;
          changed = true;
        }
      });
    } catch (e) {}

    if (stored.landing_page === undefined) {
      stored.landing_page = String(window.location.href).slice(0, 500);
      changed = true;
    }
    if (stored.referrer === undefined && document.referrer) {
      var ref = String(document.referrer);
      /* Only an external referrer says anything about where the visit began. */
      if (ref.indexOf(window.location.origin) !== 0) {
        stored.referrer = ref.slice(0, 500);
        changed = true;
      }
    }

    if (changed) writeStore(stored);
    return stored;
  }

  /* Read at checkout time: the Meta pixel sets its cookies after landing, so
   * they are fresher than anything captured earlier. */
  function collect(extra) {
    var out = {};
    var stored = capture();
    for (var k in stored) {
      if (Object.prototype.hasOwnProperty.call(stored, k) && stored[k]) out[k] = stored[k];
    }

    var fbp = cookie('_fbp');
    var fbc = cookie('_fbc');
    if (fbp) out.fbp = fbp;
    if (fbc) out.fbc = fbc;
    /* Meta accepts a reconstructed fbc when the cookie is missing but the click
     * id is known. */
    if (!out.fbc && out.fbclid) out.fbc = 'fb.1.' + Date.now() + '.' + out.fbclid;

    var ttp = cookie('_ttp');
    if (ttp) out.ttp = ttp;

    if (extra) {
      for (var e in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, e) && extra[e]) out[e] = extra[e];
      }
    }
    return out;
  }

  window.WHOP_ATTRIBUTION = { capture: capture, collect: collect };

  capture();
})();
